export class DocType {

    id:number;
    code:string;
    name:string;

  constructor() { }

}
